import { IsString } from 'class-validator';

export class TeamCodeList {
    @IsString()
    name!: string;
    @IsString()
    code!: string;
}
export interface contactCodeListResponse {
    code: string;
    name: string;
}
